export default {
  data: [],
  isLoaded: false,
  error: null,
}
